<button
  *ngIf="state.allowAssetRedirection; else pathTmpl"
  y42StopPropagation
  mat-button
  class="redirect-button"
  (click)="redirect(state.path)"
>
  <ng-container *ngTemplateOutlet="pathTmpl"></ng-container>
</button>

<ng-template #pathTmpl>
  <span>{{ state.path }}</span>
</ng-template>
